import React, { useState, useEffect } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import AdminSidebar from "../shared/AdminSidebar";
import { getNodeApiBase } from "../../../utils/apiBase";
import "./Comite.css";

const ModifierComite = () => {
  const { id_comite } = useParams();
  const navigate = useNavigate();

  const [selectedItem, setSelectedItem] = useState("Comite");
  const [titreComite, setTitreComite] = useState("");
  const [competition, setCompetition] = useState("");
  const [evaluatorInput, setEvaluatorInput] = useState("");
  const [selectedEvaluators, setSelectedEvaluators] = useState([]);
  const [competitions, setCompetitions] = useState([]);
  const [evaluteurs, setEvaluteurs] = useState([]);
  const [compLoading, setCompLoading] = useState(false);
  const [compError, setCompError] = useState('');
  const [compFetchInfo, setCompFetchInfo] = useState('');
  const apiBase = getNodeApiBase();

  // Toggle this to true only if backend is configured with specific Access-Control-Allow-Origin and credentials support
  const USE_CREDENTIALS = false;

  // Helper to build fetch options w/abort
  const baseFetchOpts = (signal) => (USE_CREDENTIALS ? { credentials: 'include', signal } : { signal });

  useEffect(() => {
    let abort = false;
    const enumerateCompetitions = async () => {
      setCompLoading(true); setCompError(''); setCompFetchInfo('Début du scan...');
      const found = []; const seen = new Set();
      let id = 1; let emptyStreak = 0;
      const MAX_ID = 2000;
      const EMPTY_LIMIT_AFTER_FOUND = 30;
      const GLOBAL_EMPTY_LIMIT = 150;
      while (!abort && id <= MAX_ID) {
        try {
          const res = await fetch(`${apiBase}/api/evaluateur/competitions/${id}`);
          if (!res.ok) {
            emptyStreak++;
          } else {
            const json = await res.json();
            if (json.status === 'success' && json.competition && json.competition.idcompetition != null) {
              const cid = json.competition.idcompetition;
              if (!seen.has(cid)) {
                seen.add(cid);
                found.push(json.competition);
              }
              emptyStreak = 0;
            } else {
              emptyStreak++;
            }
          }
        } catch { emptyStreak++; }
        if ((found.length > 0 && emptyStreak >= EMPTY_LIMIT_AFTER_FOUND) || emptyStreak >= GLOBAL_EMPTY_LIMIT) break;
        if (id % 100 === 0 && !abort) setCompFetchInfo(`Scan ID ${id} / trouvées: ${found.length}`);
        id++;
      }
      if (!abort) {
        found.sort((a,b)=>(a.idcompetition||0)-(b.idcompetition||0));
        setCompetitions(found);
        setCompFetchInfo(found.length ? `Compétitions trouvées: ${found.length}` : 'Aucune compétition détectée');
        if (!found.length) setCompError('Aucune compétition détectée par scan'); else setCompError('');
        setCompLoading(false);
      }
    };
    enumerateCompetitions();

    // Fetch evaluateurs list (simple)
    fetch(`${apiBase}/api/evaluteurs`)
      .then(r=>r.json())
      .then(d=>{ if(!abort && d.evaluteurs) setEvaluteurs(d.evaluteurs); })
      .catch(()=>{});

    return () => { abort = true; };
  }, [apiBase]);

  // Separate effect to fetch comité details (kept logic)
  useEffect(() => {
    let cancelled = false;
    fetch(`${apiBase}/api/comite/${id_comite}`)
      .then(r=>r.json())
      .then(json => {
        if (cancelled) return;
        if (json.comite) {
          setTitreComite(json.comite.titre_comite || json.comite.titre || '');
          const compId = json.comite.idcompetition || '';
          setCompetition(compId);
          setSelectedEvaluators(json.evaluateurs || []);
          // If competitions scan not yet yielded this one, inject it
          setCompetitions(prev => {
            if (prev.some(c=>c.idcompetition===compId) || !compId) return prev;
            return [...prev, { idcompetition: compId, titre: json.comite.titre_competition || `Compétition ${compId}` }];
          });
        }
      });
    return ()=> { cancelled = true; };
  }, [apiBase, id_comite]);

  // Filter evaluteurs by nom or prenom
  const filteredEvaluators = evaluteurs.filter(
    (e) =>
      ((e.nom + " " + e.prenom)
        .toLowerCase()
        .includes(evaluatorInput.toLowerCase()) ||
        (e.prenom + " " + e.nom)
          .toLowerCase()
          .includes(evaluatorInput.toLowerCase())) &&
      !selectedEvaluators.some((sel) => sel.idevaluteur === e.idevaluteur)
  );

  const handleAddEvaluator = (evaluteur) => {
    setSelectedEvaluators([...selectedEvaluators, evaluteur]);
    setEvaluatorInput("");
  };

  const handleRemoveEvaluator = (idevaluteur) => {
    setSelectedEvaluators(
      selectedEvaluators.filter((e) => e.idevaluteur !== idevaluteur)
    );
  };

  const handleUpdateComite = async (e) => {
    e.preventDefault();
    if (!competition || !titreComite) {
      alert("Veuillez remplir tous les champs obligatoires.");
      return;
    }
    try {
      // 1. Update comité
      const response = await fetch(`${apiBase}/api/comite/${id_comite}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          idcompetition: competition,
          titre_comite: titreComite,
        }),
      });
      const data = await response.json();
      if (data.success) {
        // 2. Update evaluateurs
        await fetch(`${apiBase}/api/comite/${id_comite}/evaluateurs`, {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            idevaluteurs: selectedEvaluators.map((e) => e.idevaluteur),
          }),
        });
        alert("Comité modifié avec succès !");
        navigate("/Comite");
      } else {
        alert("Erreur lors de la modification du comité : " + (data.message || ""));
      }
    } catch (err) {
      alert("Erreur lors de la modification du comité.");
    }
  };

  const labelStyle = {
    fontWeight: "bold",
    marginBottom: "0.3rem",
    display: "block",
  };

  return (
    <div>
      <AdminSidebar />

      <div className="main-content" style={{ marginLeft: '250px', width: 'calc(100vw - 250px)', padding: '2rem', display: 'flex', justifyContent: 'center', boxSizing: 'border-box' }}>
        <div
          className="card"
          style={{
            backgroundColor: "#fff",
            borderRadius: "10px",
            padding: "2rem",
            maxWidth: "1100px",
            width: "100%",
            margin: "0 auto",
            boxShadow: "0 0 10px rgba(0,0,0,0.1)",
          }}
        >
          <h2
            style={{
              fontSize: "1.5rem",
              fontWeight: "bold",
              textAlign: "center",
              marginBottom: "1.5rem",
            }}
          >
            Modifier Comité
          </h2>

          <form onSubmit={handleUpdateComite}>
            <div style={{ marginBottom: "1rem" }}>
              <label style={labelStyle}>Compétition :</label>
              <select
                className="form-control"
                value={competition}
                onChange={(e) => setCompetition(e.target.value)}
              >
                <option value="">{competitions.length ? 'Sélectionner' : 'Aucune compétition disponible'}</option>
                {competitions.map((comp) => {
                  const id = comp.idcompetition || comp.id || comp.ID || comp.Id;
                  const label = comp.titre || comp.titre_competition || comp.libelle || comp.nom || `Compétition ${id}`;
                  return (
                    <option key={id} value={id}>
                      {label}
                    </option>
                  );
                })}
              </select>
              <div style={{ marginTop: '0.4rem', fontSize: '0.8rem' }}>
                {compLoading && <span style={{ color:'#555' }}>{compFetchInfo || 'Scan des compétitions...'}</span>}
                {!compLoading && compError && <span style={{ color:'#b91c1c' }}>{compError}</span>}
                {!compLoading && !compError && <span style={{ color:'#0b7a3e' }}>{compFetchInfo}</span>}
              </div>
            </div>

            <div style={{ marginBottom: "1rem" }}>
              <label style={labelStyle}>Titre de Comité :</label>
              <input
                type="text"
                className="form-control"
                value={titreComite}
                onChange={(e) => setTitreComite(e.target.value)}
                placeholder="Entrer le titre"
              />
            </div>

            <div style={{ marginBottom: "1rem" }}>
              <label style={labelStyle}>Liste Evaluateur :</label>
              <input
                type="text"
                className="form-control"
                placeholder="Rechercher..."
                value={evaluatorInput}
                onChange={(e) => setEvaluatorInput(e.target.value)}
              />
              {evaluatorInput && (
                <ul className="list-group mt-2">
                  {filteredEvaluators.map((e, index) => (
                    <li
                      key={e.idevaluteur}
                      className="list-group-item"
                      style={{ cursor: "pointer" }}
                      onClick={() => handleAddEvaluator(e)}
                    >
                      {e.nom} {e.prenom}
                    </li>
                  ))}
                </ul>
              )}
              <div style={{ marginTop: "0.5rem", display: "flex", flexWrap: "wrap" }}>
                {selectedEvaluators.map((e, index) => (
                  <span
                    key={e.idevaluteur}
                    style={{
                      display: "inline-block",
                      padding: "0.3rem 0.6rem",
                      backgroundColor: "#e0e0e0",
                      borderRadius: "15px",
                      margin: "0.25rem",
                      fontSize: "0.9rem",
                      wordBreak: "break-word", // Prevent overflow
                    }}
                  >
                    {e.nom} {e.prenom}
                    <span
                      style={{ cursor: "pointer", marginLeft: "6px" }}
                      onClick={() => handleRemoveEvaluator(e.idevaluteur)}
                    >
                      x
                    </span>
                  </span>
                ))}
              </div>
            </div>
            <button
              type="submit"
              className="btn w-100"
              style={{ backgroundColor: "#007bff", color: "white" }}
            >
              Enregistrer les modifications
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ModifierComite;
